import ActivationInfo from "@/models/activationInfo.model";

export default class DeviceInfo {
  public id?: string;
  public label?: string;
  public status?: any;
  public visible: boolean;
  public live: boolean;
  public currentState?: any;
  public lastCommunicationDate?: string;
  public activationInfo?: ActivationInfo;

  public lastLpwanLocationDate?: Date;
  public lastTdoaLocationDate?: Date;
  public lastWifiLocationDate?: Date;

  constructor(obj: any) {
    this.id = obj?.id;
    this.label = obj?.label;
    this.status = obj?.status;
    this.activationInfo = obj?.activationInfo;
    if (obj?.lastCommunicationDate) {
      this.lastCommunicationDate = new Date(obj?.lastCommunicationDate).toISOString();
    } else {
      this.lastCommunicationDate = new Date(0).toISOString();
    }

    this.lastLpwanLocationDate = this.getLocationDate("lpwan");
    this.lastTdoaLocationDate = this.getLocationDate("tdoa");
    this.lastWifiLocationDate = this.getLocationDate("wifi");

    this.visible = true;
    this.live = false;

    this.updateCurrentStatus();
  }

  public getStatus() {
    let status: any[] = [];
    if (this.status && this.status.requested) {
      status = Object.keys(this.status.requested).map((key) => {
        return {
          property: key,
          requested: JSON.stringify(this.status?.requested[key]?.data),
          requestedDate: this.status?.requested[key]?.date,
          reported: JSON.stringify(this.status?.reported[key]?.data),
          reportedDate: this.status?.reported[key]?.date,
        };
      });
    }
    return status;
  }

  public getLocationDate(locationType: "lpwan" | "tdoa" | "wifi") {
    const date = this.status?.reported[locationType + "Location"]?.date;
    if (!date) {
      return new Date(0).toISOString();
    } else {
      return date;
    }
  }

  public shouldShowStartRecoveryButton() {
    const requestedRecovery = this.status.requested?.recovery?.data;
    const recoveryRequestedDate = this.status.requested?.recovery?.date;
    const recoveryReportedDate = this.status.reported?.recovery?.date;
    return (!this.currentState.recovery && recoveryReportedDate >= recoveryRequestedDate) ||
      (requestedRecovery === false && recoveryRequestedDate >= recoveryReportedDate);
  }

  public shouldShowStopRecoveryButton() {
    const requestedRecovery = this.status.requested?.recovery?.data;
    const recoveryRequestedDate = this.status.requested?.recovery?.date;
    const recoveryReportedDate = this.status.reported?.recovery?.date;
    return (this.currentState.recovery && recoveryReportedDate >= recoveryRequestedDate) ||
      (requestedRecovery === true && recoveryRequestedDate >= recoveryReportedDate);
  }

  public shouldShowChangeLifetimeButton() {
    return this.shouldShowStartRecoveryButton();
  }

  public shouldShowRequestLocation() {
    const locationRequestedDate = this.status.requested?.location?.date;
    return this.shouldShowStartRecoveryButton();
  }

  public shouldShowEnableIdentificationButton() {
    return this.shouldShowStartRecoveryButton() && !this.currentState.identification;
  }

  public shouldShowDisableIdentificationButton() {
    return this.shouldShowStartRecoveryButton() && this.currentState.identification;
  }

  public updateCurrentStatus() {
    const currentState = {
      battery: 0,
      temperature: 0,
      identification: false,
      intervalInMinutes: 0,
      recovery: false,
    };

    if (this.status.reported.batteryLevel) {
      currentState.battery = this.status.reported.batteryLevel.data / 1000;
    }

    if (this.status.reported.temperatureLevel) {
      currentState.temperature = this.status.reported.temperatureLevel.data;
    }

    if (this.status.reported.identification) {
      currentState.identification = this.status.reported.identification.data;
    }

    if (this.status.reported.intervalInMinutes) {
      currentState.intervalInMinutes = this.status.reported.intervalInMinutes.data;
    }

    if (this.status.reported.recovery) {
      currentState.recovery = this.status.reported.recovery.data;
    }

    this.currentState = currentState;
  }
}
